/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const MailSendSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><g clipPath="url(#a)"><path d="M21.803 2.096a1 1 0 0 1 .24 1.05l-6.817 19.018c-.47 1.309-2.313 1.33-2.812.032l-2.417-6.285a.5.5 0 0 1 .091-.51L20.267 3.87 8.443 13.98a.5.5 0 0 1-.504.087L1.968 11.77c-1.286-.495-1.281-2.316.008-2.804l18.773-7.092a1 1 0 0 1 1.054.222Z" /></g><defs><clipPath id="a"><path d="M0 0h24v24H0z" /></clipPath></defs></svg>);
const MailSendSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={MailSendSolidBase} {...rest} ref={ref} />);
export default MailSendSolid;